"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.indexSymbols = void 0;
exports.indexSymbols = [
    {
        name: 'S&P 500',
        symbol: 'CSPX',
        exchange: 'LSE',
        date: new Date('2010-09-15'),
    },
    {
        name: 'NASDAQ 100',
        symbol: 'CNDX',
        exchange: 'LSE',
        date: new Date('2010-09-15'),
    },
    {
        name: 'BTC',
        symbol: 'BTC-USD',
        exchange: 'CC',
        date: new Date('2010-07-17'),
    },
];
//# sourceMappingURL=index-symbols.js.map